/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * API
 * OpenAPI spec version: 1.0.0
 */

export type GetApiDoctorsPortalLogsSortOrder =
    (typeof GetApiDoctorsPortalLogsSortOrder)[keyof typeof GetApiDoctorsPortalLogsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiDoctorsPortalLogsSortOrder = {
    asc: 'asc',
    desc: 'desc',
} as const;
